import React from "react";
import { BaseBean, RestReportBean } from "../ds/client_ds.js";
import { Button, Col, FormLabel, Row } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import CustomTable from "../gui_components/CustomTable.js";
import {
  FabricStyleBarCodeSearchCriteria,
  RestPageListBean,
  FabricStyleFabricStyleBarCodeListRequest,
  CustomerSearchCriteria,
  RestCustomerListRequest,
  RestReadRequest,
  FabricStyleSearchCriteria,
  RestFabricStyleListBeanRequest,
  FabricStyleSKUBean,
  FabricStyleBarCodeResultBean,
} from "../ds/ds.js";
import {
  AlertToolBox,
  ProgressBar,
  ShowError,
  InputTextbox,
  ColumnDefinition,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { ReportService } from "../services/ReportService.js";
import { BaseInquiryToolBar } from "./BaseModule.js";
class PalletBarCodeGenerator extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: false,
      isShowResetButton: false,
      isShowExitButton: true,
      pageTitle: "Pallet BarCode Generator",
      error_list: [],
      inquiryDataList: [],
      selectedList: [],
      criteria: new FabricStyleBarCodeSearchCriteria(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMessage: [],
      alertType: "",
      alertMsg: "",
      success_list: [],
      moduleForPopup: [],
      isDisabledFields: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      is3PL: false,
      customerLookupHandler: null,
      fabricLookupHandler: null,
      isShowColorLookup: false,
      colorLookupHandler: null,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: true,
      showAutoCompleteFabricColorList: true,
      showAutoCompleteCustomerList: true,
      customerPageListForAutoCompleteList: new Array(),
      disableTextField: true,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    const criteria = this.state.criteria;
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({
      customerLookupHandler: customerLookupHandler,
    });
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "FabricStyle",
      this.state.is3PL ? criteria.logisticCustomerCode : ""
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
  };

  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  disable = () => {
    this.setState({
      isDisabledFields: true,
    });
  };

  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };

  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };

  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };

  loadPage = () => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing ...",
    });
    const criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;

    if (
      !isEmptyString(criteria.logisticCustomerCode)
      // !isEmptyString(criteria.fabricStyleCode)
    ) {
      this.loadList(criteria);
    } else {
      let errMsg = "Customer or Item is required!";
      let errList = this.state.error_list;
      errList.push(errMsg);
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  loadList = (criteria) => {
    if (SecurityAccessManager.PalletBarCodeGeneratorModule_IsAccessible()) {
      ReportService.inquireFabricStyleBarCodePalletDetails(
        criteria,
        this.loadResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null) {
      let resultList = new Array();
      if (
        !isEmpty(response.data.result) &&
        !isEmptyArray(response.data.result.infos)
      ) {
        resultList = response.data.result.infos;
        this.setState({
          inquiryDataList: resultList,
        });
      }
      this.setState({
        inquiryDataList: resultList,
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        isShowLookup: false,
        isShowColorLookup: false,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  errorCallBack = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error: " + error);
  };
  lineSelectAll = (e) => {
    if (e.detail == 1) {
      let list = this.state.inquiryDataList;
      list.map((line) => {
        line.isActive = true;
      });
      this.setState({ selectedList: list });
    }
  };
  lineUnSelectAll = (e) => {
    if (e.detail == 1) {
      let list = this.state.inquiryDataList;
      list.map((line) => {
        line.isActive = false;
      });
      this.setState({ selectedList: [] });
    }
  };

  handleResponse = (response) => {
    let isValid = false;
    let errMsg = "";
    let infoMsg = "";
    let errList = [];
    if (response.infos != null) {
      response.infos.map(
        (info) => (infoMsg = infoMsg + "\n" + info.messageDescription)
      );
      let successMsg = [];
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
      isValid = true;
    }
    if (response.errors != null) {
      response.errors.map(
        (err) => (
          (errMsg = errMsg + "\n" + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      isValid = false;
    }
    return isValid;
  };

  onLogisticCustomerChange = (e) => {
    let logisticCustomerCode = e.target.value;
    this.state.showAutoCompleteLogisticCustomerList = true;
    let criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteLogisticCustomerList;
    if (isEmpty(logisticCustomerCode)) {
      this.state.showAutoCompleteLogisticCustomerList = false;
      let showAutoCompleteList =
        this.state.showAutoCompleteLogisticCustomerList;
      let temp_criteria = this.state.criteria;
      temp_criteria.logisticCustomerCode = "";
      temp_criteria.logisticCustomerName = "";
      temp_criteria.fabricStyleCode = "";
      temp_criteria.fabricStyleName = "";
      temp_criteria.colorCode = "";

      let suggestion = [];
      let fabricLookupHandler = new FabricStyleLookupHandler(
        this.companyCode,
        this.state.is3PL ? "Item" : "FabricStyle",
        temp_criteria.logisticCustomerCode
      );
      this.setState({
        fabricLookupHandler: fabricLookupHandler,
        isShowColorLookup: false,
      });
      this.setState({
        showAutoCompleteLogisticCustomerList: showAutoCompleteList,
        criteria: temp_criteria,
        logisticCustomerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "logisticCustomerCode" &&
      showAutoCompleteList === true &&
      logisticCustomerCode !== ""
    ) {
      this.readLogisticCustomerBySearchString(e.target.value);
    }
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
    //this.readLogisticCustomer(logisticCustomerCode);
  };

  readLogisticCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByLogisticCustomerCodeResponse,
      this.errorCallBack
    );
  }
  readByLogisticCustomerCodeResponse = (response) => {
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.customerPageList) &&
      !isEmptyArray(response.data.customerPageList.customers)
    ) {
      let customerList = response.data.customerPageList.customers;
      let simpleAutoCompleteList = new Array();
      if (customerList.length > 0 && customerList != null) {
        customerList.map((customer) => {
          let simpleItemBean = {
            code: customer.code,
            description: customer.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        logisticCustomerPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };

  readLogisticCustomerResponse = (response) => {
    if (!isEmpty(response.data) && !isEmpty(response.data.customer)) {
      let customerData = response.data.customer;
      let criteria = this.state.criteria;
      criteria.logisticCustomerCode = customerData.code;
      criteria.logisticCustomerName = customerData.description;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      criteria.colorCode = "";
      this.setState({ criteria: criteria, isShowColorLookup: false });
      let fabricLookupHandler = new FabricStyleLookupHandler(
        this.companyCode,
        // "Item",
        this.state.is3PL ? "Item" : "FabricStyle",
        criteria.logisticCustomerCode
      );
      this.setState({ fabricLookupHandler: fabricLookupHandler });
    }
  };

  readLogisticCustomer = (logisticCustomerCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = logisticCustomerCode;
    readrestInput.isLoadChildren = true;
    CustomerService.readCustomerWithChildren(
      readrestInput,
      this.readLogisticCustomerResponse,
      this.errorCallBack
    );
  };
  logisticCustomerEnterKeyEventHandler = (e) => {
    let logisticCustomerCode = e.target.value;
    this.readLogisticCustomer(logisticCustomerCode);
    this.setState({
      logisticCustomerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteLogisticCustomerList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteLogisticCustomerList: showAutoCompleteList,
    });
  };

  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteFabricList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
        fabricPageListForAutoCompleteList: suggestion,
        isShowColorLookup: false,
        colorList: [],
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetFabricStyleDetailResponse = (response) => {
    let criteria = this.state.criteria;
    this.setState({ isFabricStyleDataLoding: false });
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;
        criteria.colorCode = "";
        let colors = fabricStyle.colors;
        let finalColorList = [];
        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        this.setState({ colorLookupHandler: null });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color"
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
            isShowColorLookup: true,
            criteria: criteria,
            colorList: finalColorList,
            fabricStyleData: fabricStyle,
            isShowProgressBarPopup: false,
            progressLoadingText: "",
          });
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readandsetFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    this.setState({ isFabricStyleDataLoding: true });
    FabricStyleService.readFabricStyle(
      input,
      this.readandsetFabricStyleDetailResponse,
      this.errorCallBack
    );
  };
  readFabricBySearchString(searchString) {
    const criteria = this.state.criteria;
    const searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    searchCriteria.logisticCustomerCode = criteria.logisticCustomerCode;
    const pageList = new RestPageListBean();
    pageList.pageSize = 100;
    const input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.errorCallBack
    );
  }
  readByFabricCodeResponse = (response) => {
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.fabricStylePageList) &&
      !isEmptyArray(response.data.fabricStylePageList.fabricStyles)
    ) {
      let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
      let criteria = this.state.criteria;
      let simpleAutoCompleteList = new Array();
      if (fabricStyleData.length > 0 && fabricStyleData != null) {
        fabricStyleData.map((fabricStyle) => {
          // if (this.state.is3PL) {
          //   if (fabricStyle.customerCode == criteria.logisticCustomerCode) {
          //     let simpleItemBean = {
          //       code: fabricStyle.fabricStyleCode,
          //       description: fabricStyle.fabricStyleName,
          //     };
          //     simpleAutoCompleteList.push(simpleItemBean);
          //   }
          // } else {
          let simpleItemBean = {
            code: fabricStyle.fabricStyleCode,
            description: fabricStyle.fabricStyleName,
          };
          simpleAutoCompleteList.push(simpleItemBean);
          // }
        });
      }
      this.setState({
        fabricPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
    });
    this.readandsetFabricStyleDetail(fabricStyleCode);
    this.setState({
      fabricPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteList });
  };

  onFabricColourCodeChange = (e) => {
    this.state.showAutoCompleteFabricColorList = true;
    let colorCode = e.target.value;
    let showAutoCompleteFabricColorList =
      this.state.showAutoCompleteFabricColorList;
    if (isEmpty(colorCode)) {
      this.state.showAutoCompleteFabricColorList = false;
      let showAutoCompleteFabricColorList =
        this.state.showAutoCompleteFabricColorList;
      let criteria = this.state.criteria;
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "colorCode" &&
      showAutoCompleteFabricColorList === true &&
      colorCode !== ""
    ) {
      this.readFabricColourBySearchString(e.target.value);
    }
    this.fabricStyleColorSelected(e.target.value);
  };
  readFabricColourBySearchString(searchString) {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.fabricStyleColorCode == searchString
        )
          skuBean = sku;
      });
    }
    criteria.colorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourEnterKeyEventHandler = (e) => {
    let fabricStyleColourCode = e.target.value;
    this.fabricStyleColorSelected(e.target.value);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricColorList: showAutoCompleteList });
  };
  fabricStyleColorSelected = (colorCode) => {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.fabricStyleColorCode == colorCode
        )
          skuBean = sku;
      });
    }
    criteria.colorCode = colorCode;
    this.setState({ criteria: criteria });
  };

  rollLineCheck = (e, rowData) => {
    // let selectedLine = [];
    // if (e.target.value != 0)
    let selectedList = this.state.selectedList;
    rowData[e.target.name] = e.target.value;
    if (rowData.isActive === true) {
      selectedList.push(rowData);
      this.setState({ selectedList: selectedList });
    } else {
      rowData.numberOfBoxes = 0;
      let selectedList = this.state.selectedList;
      let rollList = [];
      for (let roll of selectedList) {
        if (roll.isActive != rowData.isActive) {
          rollList.push(roll);
          this.setState({ selectedList: rollList });
          this.state.selectedList = rollList;
        } else if (selectedList.length == 1) {
          this.setState({ selectedList: [] });
        }
      }
    }
  };

  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  clearCriteria = () => {
    let tempCriteria = new FabricStyleBarCodeSearchCriteria();
    tempCriteria.companyCode = this.companyCode;
    tempCriteria.logisticCustomerName = "";
    tempCriteria.fabricStyleName = "";
    this.setState({
      criteria: tempCriteria,
    });
    this.hideAlertCallBack();
  };
  resetView = () => {
    let criteria = new FabricStyleBarCodeSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.logisticCustomerName = "";
    criteria.fabricStyleName = "";
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowLookup: true,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isDisabledFields: false,
      selectedList: new Array(),
    });
    this.hideAlertCallBack();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  moduleExit = () => {
    this.props.onModuleExit();
  };
  inputOnChange = (e, data) => {
    let inquiryDataList = this.state.inquiryDataList;
    if (!isEmpty(data) && data.isActive) {
      // if (data.isActive) {
      //   data.numberOfBoxes = e.target.value;
      // }
      inquiryDataList.map((ln) => {
        if (ln.skuNumber == data.skuNumber) ln[e.target.name] = e.target.value;
      });
    }
    // if (!isEmpty(data)) {
    //   data.numberOfBoxes = e.target.value;
    //   // data.isActive = true;
    // }
  };
  inputOnBlur = (e, data) => {
    if (!isEmpty(data)) {
      // data.numberOfBoxes = e.target.value;
      // data.isActive = true;
      // if (data.isActive == true) data.numberOfBoxes = e.target.value;
    }
  };

  getColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("", "isActive", false)
        .setInputDetails(false, false, true, null, this.rollLineCheck, null)
        .setStyleDetails("", "", "", "wt-1-5 ", "wt-1-5 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "7", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Item", "fabricStyleCode", true)
        .setStyleDetails("left", "7", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "fabricStyleName", true)
        .setStyleDetails("left", "7", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SKU", "skuNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("NoOfPallets", "numberOfBoxes", true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 ")
        .setInputDetails(
          false,
          true,
          false,
          this.inputOnChange,
          null,
          this.inputOnBlur
        )
      // .setDisabled(this.state.disableTextField)
    );
    return columns;
  };
  validateLines = (lines) => {
    let isValid = false;
    let selectedList = new Array();
    selectedList = lines.filter((ln) => ln.isActive == true);
    if (!isEmptyArray(selectedList)) {
      isValid = true;
    } else {
      isValid = false;
      let errMsg = "Select Lines";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertType: "danger",
        alertMessage: errList,
        isShowAlert: true,
      });
    }
    return isValid;
  };
  generateBarCodeResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
  };
  generateBarCodeLabel = () => {
    this.setState({
      isLoading: true,
      loadingText: "Generate BarCode",
    });
    const selectedList = this.state.selectedList;
    const input = new FabricStyleFabricStyleBarCodeListRequest();
    const data = new FabricStyleBarCodeResultBean();
    const infos = new Array();
    selectedList.map((ln) => {
      ln.companyCode = this.companyCode;
      infos.push(ln);
    });
    data.infos = infos;
    input.criteria = data;
    const reportBean = new RestReportBean();
    reportBean.reportType = 1;
    input.reportBean = reportBean;

    const isValid = this.validateLines(infos);
    if (isValid) {
      if (
        SecurityAccessManager.PalletBarCodeGeneratorModulePDFReport_IsAccessible()
      ) {
        ReportService.createFabricStyleBarCodePalletDetailsAndPrintReport(
          input,
          this.generateBarCodeResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  render() {
    let inquiryDataList = new Array();
    // if (!isEmptyArray(inquiryDataList))
    inquiryDataList = this.state.inquiryDataList;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowExitButton={this.state.isShowExitButton}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          onModuleExit={this.moduleExit}
          reset={this.resetView}
        />
        <CriteriaView
          {...this.state}
          onChange={this.onChange}
          loadPage={this.loadPage}
          fabricLookupHandler={this.state.fabricLookupHandler}
          customerLookupHandler={this.state.customerLookupHandler}
          fabricCodeOnChange={this.fabricCodeOnChange}
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
          fabricColourEnterKeyEventHandler={
            this.fabricColourEnterKeyEventHandler
          }
          displayAutoCompleteFabricColorList={
            this.displayAutoCompleteFabricColorList
          }
          onFabricColourCodeChange={this.onFabricColourCodeChange}
          onLogisticCustomerChange={this.onLogisticCustomerChange}
          logisticCustomerEnterKeyEventHandler={
            this.logisticCustomerEnterKeyEventHandler
          }
          displayAutoCompleteLogisticCustomerList={
            this.displayAutoCompleteLogisticCustomerList
          }
        />
        {this.state.isInquiryDatasFound && (
          <Row>
            <Col sm="1">
              <Button
                size="sm"
                id="fabric_Add_Button"
                onClick={(e) => this.lineSelectAll(e)}
              >
                SelectAll
              </Button>
            </Col>
            <Col sm="1">
              <Button
                size="sm"
                id="fabric_Add_Button"
                onClick={(e) => this.lineUnSelectAll(e)}
              >
                UnSelectAll
              </Button>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <Button
                size="sm"
                id="fabric_Add_Button"
                onClick={(e) => this.generateBarCodeLabel(e)}
              >
                Print BarCode
              </Button>{" "}
            </Col>
          </Row>
        )}
        {this.state.isInquiryDatasFound && (
          <div className="div_default">
            {/* <EditableDataGrid
              columnsList={this.columnDefinitions()}
              dataList={inquiryDataList}
            /> */}
            <CustomTable
              data={inquiryDataList}
              columns={this.getColumns()}
              label={"Pallet Lines"}
            />
          </div>
        )}
      </div>
    );
  }
}
export function CriteriaView(props) {
  const criteria = props.criteria;
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          <FormLabel>Customer</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            onChange={props.onLogisticCustomerChange}
            value={criteria.logisticCustomerCode}
            name="logisticCustomerCode"
            placeholder="customer"
            lookupRequired={true}
            lookupHandler={props.customerLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={props.logisticCustomerEnterKeyEventHandler}
            autoCompleteListData={
              props.logisticCustomerPageListForAutoCompleteList
            }
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={
              props.displayAutoCompleteLogisticCustomerList
            }
            showAutoCompleteList={props.showAutoCompleteLogisticCustomerList}
            disabled={false}
            isMandatory={true}
          />
        </Col>
        <Col sm="3">
          <InputTextbox
            value={criteria.logisticCustomerName}
            name="logisticCustomerName"
            disabled={true}
          />
        </Col>
        <Col sm="1">
          <FormLabel>Item</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            // ref={fabricCodeRef}
            name="fabricStyleCode"
            onChange={props.fabricCodeOnChange}
            value={criteria.fabricStyleCode}
            placeholder="item"
            lookupRequired={true}
            lookupHandler={props.fabricLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={props.fabricEnterKeyEventHandler}
            autoCompleteListData={props.fabricPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={props.displayAutoCompleteFabricList}
            showAutoCompleteList={props.showAutoCompleteFabricList}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="3">
          <InputTextbox
            name="fabricStyleName"
            onChange={props.fabricCodeOnChange}
            value={criteria.fabricStyleName}
            disabled={true}
          />
        </Col>
      </Row>
      <Row>
        <Col sm="1">
          {" "}
          <FormLabel>Color</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            onChange={props.onFabricColourCodeChange}
            name="colorCode"
            placeholder="color"
            value={criteria.colorCode}
            lookupRequired={props.isShowColorLookup}
            lookupHandler={props.colorLookupHandler}
            enterKeyEventHandler={props.fabricColourEnterKeyEventHandler}
            autoCompleteListData={props.fabricColourPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={props.displayAutoCompleteFabricColorList}
            showAutoCompleteList={props.showAutoCompleteFabricColorList}
            disabled={!props.isShowColorLookup}
            isMandatory={true}
          />
        </Col>
      </Row>
    </div>
  );
}
function PalletBarCodeGeneratorModule(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div className="App">
        <PalletBarCodeGenerator {...props} name="" /> <br />
      </div>
    </div>
  );
}

export default PalletBarCodeGeneratorModule;
